/**
 * API helper — Sobeca
 * Wrapper autour de fetch() avec credentials (cookies httpOnly).
 * Pas de CSRF, pas de mode offline.
 */

const API_BASE = "/api";

async function request(path, options = {}) {
  const headers = {
    "Content-Type": "application/json",
    ...options.headers,
  };

  const response = await fetch(`${API_BASE}${path}`, {
    ...options,
    credentials: "include",
    headers,
  });
  return response;
}

// ==================== Authentification ====================

export async function login(username, password) {
  const res = await request("/auth/login", {
    method: "POST",
    body: JSON.stringify({ username, password }),
  });
  return res;
}

export async function logout() {
  const res = await request("/auth/logout", { method: "POST" });
  return res;
}

export async function getMe() {
  const res = await request("/auth/me");
  return res;
}

// ==================== Liste personnelle ====================

export async function getPersonalList(page = 1, limit = 50) {
  const res = await request(`/list/personal?page=${page}&limit=${limit}`);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const data = await res.json();
  return { items: data.items || [], total: data.total || 0, page: data.page || 1, pages: data.pages || 1 };
}

export async function addItem(data) {
  const res = await request("/list/personal", {
    method: "POST",
    body: JSON.stringify(data),
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
}

export async function updateItem(id, data) {
  const res = await request(`/list/personal/${id}`, {
    method: "PUT",
    body: JSON.stringify(data),
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
}

export async function deleteItem(id) {
  const res = await request(`/list/personal/${id}`, {
    method: "DELETE",
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
}

export async function reorderItems(order) {
  const res = await request("/list/personal/reorder", {
    method: "PUT",
    body: JSON.stringify({ order }),
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
}

export async function clearCheckedPersonal() {
  const res = await request("/list/personal/checked", {
    method: "DELETE",
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
}

// ==================== Liste commune ====================

export async function getSharedList(page = 1, limit = 50) {
  const res = await request(`/list/shared?page=${page}&limit=${limit}`);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const data = await res.json();
  return { items: data.items || [], total: data.total || 0, page: data.page || 1, pages: data.pages || 1 };
}

export async function checkGroupItems(ids) {
  const res = await request("/list/shared/check-group", {
    method: "PUT",
    body: JSON.stringify({ ids }),
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
}

export async function clearCheckedShared() {
  const res = await request("/list/shared/checked", {
    method: "DELETE",
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
}

// ==================== Catégories ====================

export async function getCategories() {
  const res = await request("/categories");
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
}

// ==================== Admin ====================

export async function getUsers() {
  const res = await request("/admin/users");
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json();
}

export async function createUser(data) {
  const res = await request("/admin/users", {
    method: "POST",
    body: JSON.stringify(data),
  });
  if (!res.ok) {
    const err = await res.json();
    throw new Error(err.error || `HTTP ${res.status}`);
  }
  return res.json();
}

export async function deleteUser(id) {
  const res = await request(`/admin/users/${id}`, {
    method: "DELETE",
  });
  if (!res.ok) {
    const err = await res.json();
    throw new Error(err.error || `HTTP ${res.status}`);
  }
  return res.json();
}
